import React from "react";
import { observer } from "mobx-react-lite";

const FavoritesView = observer(({ favorites, onRemove }) => (
  <div className="favorites-view">
    <h2>Favorites</h2>
    <h3>Paintings</h3>
    {favorites.paintings.length === 0 ? (
      <p>No favorites added yet</p>
    ) : (
      <div className="results-container">
        {favorites.paintings.map((painting, index) => (
          <div key={index} className="artwork-card">
            <h3 className="artwork-title">{painting.title}</h3>
            <p>
              <strong>Artist:</strong> {painting.artistName || "Unknown"}
            </p>
            {painting.image && (
              <img
                src={painting.image}
                alt={painting.title}
                className="artwork-image"
              />
            )}
            <button
              className="remove-button"
              onClick={() => onRemove(painting, "painting")}
            >
              Remove
            </button>
          </div>
        ))}
      </div>
    )}
    <h3>Artists</h3>
    {favorites.artists.length === 0 ? (
      <p>No favorites added yet</p>
    ) : (
      <div className="results-container">
        {favorites.artists.map((artist, index) => (
          <div key={index} className="artwork-card">
            <h3 className="artwork-title">{artist.artistName}</h3>
            <button
              className="remove-button"
              onClick={() => onRemove(artist, "artist")}
            >
              Remove
            </button>
          </div>
        ))}
      </div>
    )}
  </div>
));

export default FavoritesView;